import React from "react";
import { Shield } from "lucide-react";

/**
 * Modal inline para decisión de validación TIC (aprobar/aprobar con condiciones/rechazar).
 *
 * Iter309 · C04 — "aprobar con condiciones" exige texto de condiciones (no basta
 * un comentario libre), y queda trazado y visible para el CFO.
 * Props:
 *   open, form ({action, comments, conditions?}), onFormChange, onCancel, onConfirm, loading
 */
export function ItValidateModal({ open, form, onFormChange, onCancel, onConfirm, loading }) {
  if (!open) return null;
  const isConditional = form.action === "approve_with_conditions";

  return (
    <div className="mt-4 p-4 border border-gray-200 rounded-xl space-y-3 bg-gray-50" data-testid="it-validate-modal">
      <div className="flex items-center gap-2 mb-1">
        <Shield size={15} className="text-[#007934]" />
        <p className="text-sm font-semibold text-gray-900">Decisión Validación TIC</p>
      </div>
      <div className="flex gap-2">
        {[
          ["approve", "Validar y escalar", "bg-green-500 border-green-500 text-white"],
          ["approve_with_conditions", "Validar con condiciones", "bg-amber-500 border-amber-500 text-white"],
          ["reject",  "Rechazar",                 "bg-red-500 border-red-500 text-white"],
        ].map(([val, label, cls]) => (
          <button
            key={val}
            onClick={() => onFormChange({ ...form, action: val })}
            data-testid={`it-action-${val}`}
            className={`flex-1 py-2.5 text-xs font-semibold rounded-lg border-2 transition-all ${
              form.action === val ? cls : "border-gray-200 text-gray-600 bg-white"
            }`}
          >
            {label}
          </button>
        ))}
      </div>
      {isConditional && (
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-3" data-testid="it-conditions-box">
          <label className="text-xs font-bold text-amber-800 mb-1 block">Condiciones exigidas (obligatorio)</label>
          <textarea
            rows={2}
            value={form.conditions || ""}
            onChange={e => onFormChange({ ...form, conditions: e.target.value })}
            placeholder="Ej: supeditado a reducir el CAPEX por debajo de 150.000€ antes de presentar..."
            data-testid="it-conditions-input"
            className="w-full border border-amber-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-amber-500 resize-none"
          />
        </div>
      )}
      <div>
        <label className="text-xs font-semibold text-gray-600 mb-1 block">
          Comentarios {form.action === "reject" ? "(obligatorio)" : "(opcional)"}
        </label>
        <textarea
          rows={3}
          value={form.comments}
          onChange={e => onFormChange({ ...form, comments: e.target.value })}
          placeholder="Justificación, ajustes necesarios..."
          className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#007934] resize-none"
        />
      </div>
      <div className="flex gap-2">
        <button
          onClick={onCancel}
          className="flex-1 border border-gray-200 text-gray-600 rounded-lg py-2 text-sm hover:bg-gray-50"
        >
          Cancelar
        </button>
        <button
          onClick={onConfirm}
          disabled={loading || (form.action === "reject" && !form.comments) || (isConditional && !(form.conditions || "").trim())}
          className="flex-1 bg-[#007934] text-white rounded-lg py-2 text-sm font-semibold hover:bg-[#006528] disabled:opacity-50"
          data-testid="confirm-it-validate-btn"
        >
          {loading ? "Procesando…" : "Confirmar decisión TIC"}
        </button>
      </div>
    </div>
  );
}
